import React, { useEffect } from "react";
import { Table, Space, Switch } from "antd";
import { ColumnsType } from "antd/es/table";
import { useTechnicianModel } from "../technicianModel";
import { ITechnicianDetail } from "../technicianType";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, selectedRow, onDisabled,
        loadData, setSelectedRowKeys, setSelectedRow,
    } = useTechnicianModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const columns: ColumnsType<ITechnicianDetail> = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 80,
            render: (text, record, index) => `${index + 1}`
        }, {
            // title: '姓名',
            title: Locale["Name"],
            dataIndex: 'name',
        }, {
            // title: '手机',
            title: Locale["Phone"],
            dataIndex: 'phone',
        }, {
            // title: '职位',
            title: Locale["Post"],
            dataIndex: 'title',
        }, {
            // title: '分配点数',
            title: Locale["Assigned Points"],
            dataIndex: 'assignPoints',
        }, {
            // title: '操作',
            title: Locale["Operation"],
            dataIndex: 'enable',
            render: (text, record) => (
                <Space size="middle">
                    <Switch checked={record.enable === 1} onChange={(checked) => {
                        onDisabled(record.id as string, checked);
                    }} />
                </Space>
            ),

        }
    ];
    useEffect(() => {
        loadData()
    }, []);

    //点击行选高亮
    const onRow = (record: ITechnicianDetail) => {
        console.log(record)
        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.id) {
            setSelectedRowKeys([])
            setSelectedRow([])
        } else {
            setSelectedRowKeys([record.id as string])
            setSelectedRow([record])
        }
    };

    return (
        <Table
            rowKey={record => record.id as string}
            rowSelection={{
                type: "radio",
                selectedRowKeys: selectedRowKeys, //记录选中
                onChange: (selectedRowKeys: React.Key[], selectedRows: ITechnicianDetail[]) => {
                    setSelectedRow(selectedRows)
                    setSelectedRowKeys(selectedRowKeys as string[]);
                }
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                // ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record)
            })}
            scroll={{ x: 'max-content' }}
        />
    )
}
